'use strict';

var chunkJHFKSNYO_js = require('./chunk-JHFKSNYO.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var i=Symbol("EXCLUDE"),r=Symbol("INCLUDE");function y(d,...a){let f=a.map(t=>{if(!chunkJHFKSNYO_js.a(t))return t;let n=Object.entries(t);return n.some(([s,l])=>l===void 0)?n.reduce((s,[l,c])=>(c!==void 0&&(s[l]=c),s),{}):t}),e=Object.assign(d,...f);if(r in e){let t=typeof e[r]=="string"?e[r].split(","):Array.isArray(e[r])?e[r]:[e[r]];Object.keys(e).forEach(n=>{t.includes(n)||delete e[n];}),delete e[r];}return i in e&&((typeof e[i]=="string"?e[i].split(","):Array.isArray(e[i])?e[i]:[e[i]]).forEach(n=>delete e[n]),delete e[i]),e}

exports.a = i;
exports.b = r;
exports.c = y;
